import { useCallback, useEffect, useState } from "react";
import {
  addCdrToStaging,
  CDR_STAGING_CHANGE_EVENT,
  clearCdrStaging,
  loadCdrStagingItems,
  removeCdrFromStaging,
} from "@/utils/cdrStagingBasket";
import { buildPublicRecordingUrl } from "@/utils/publicRecordingUrl";

const useCdrStagingBasket = () => {
  const [items, setItems] = useState(() => loadCdrStagingItems());

  useEffect(() => {
    const sync = () => setItems(loadCdrStagingItems());
    window.addEventListener(CDR_STAGING_CHANGE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(CDR_STAGING_CHANGE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const add = useCallback((record) => {
    const publicRecordingUrl = buildPublicRecordingUrl(record?.id);
    const result = addCdrToStaging(record, { publicRecordingUrl });
    if (result.ok) setItems(result.items);
    return result;
  }, []);

  const remove = useCallback((id) => {
    setItems(removeCdrFromStaging(id));
  }, []);

  const clear = useCallback(() => {
    setItems(clearCdrStaging());
  }, []);

  return { items, count: items.length, add, remove, clear };
};

export default useCdrStagingBasket;
